import Type from "@/model/types/Type";

const type = {
    CUSTOMER: 1,
    GROUP_CUSTOMER: 2,
    MARKET_CODE: 3,
}

const list = [
    {
        value: type.CUSTOMER,
        text: "Cliente",
    },
    {
        value: type.GROUP_CUSTOMER,
        text: "Grupo de Cliente",
    },
    {
        value: type.MARKET_CODE,
        text: "Código Mercado",
    },
]

const contains = function (typeInput) {
    return Type.contains(list, typeInput)
}

export default {
    type,
    list,
    contains,
}